import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const TOOL_LINKS = [
  { label: "Capital Gain Calculator", path: "/tools/capital-gain" },
  { label: "TDS Calculator", path: "/tools/tds-calculator" },
  { label: "Bank Statement", path: "/tools/bank-statement" },
  { label: "Property Gain", path: "/tools/property-gain" },
  { label: "Overseas TDS", path: "/tools/overseas-tds" },
];

const COMPANY_LINKS = [
  { labelKey: "footer.about", path: "/about" },
  { labelKey: "footer.faq", path: "/faq" },
  { label: "Pricing", path: "/pricing" },
  { labelKey: "footer.contact", path: "/contact" },
];

const LEGAL_LINKS = [
  { labelKey: "footer.terms", path: "/terms" },
  { labelKey: "footer.privacy", path: "/privacy" },
  { labelKey: "footer.help", path: "/help" },
  { labelKey: "footer.feedback", path: "/feedback" },
];

export default function Footer() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) { setSubscribed(true); }
  };

  return (
    <footer style={{ background: "#050505", borderTop: "1px solid rgba(201,168,76,0.15)", padding: "56px 32px 32px" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>

        {/* Top row */}
        <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 1fr 1fr 1.4fr", gap: "40px", marginBottom: "48px" }} className="footer-top-grid">

          {/* Logo + tagline */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px" }}>
              <div className="logo-shine" style={{ background: "#C9A84C", width: "34px", height: "34px", borderRadius: "7px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "17px", color: "#2C2C2C", fontStyle: "italic" }}>T</div>
              <span style={{ color: "white", fontWeight: 700, fontSize: "17px" }}>Tax<span style={{ color: "#C9A84C" }}>Thinker</span></span>
            </div>
            <p style={{ color: "rgba(255,255,255,0.3)", fontSize: "13px", lineHeight: 1.7, maxWidth: "200px" }}>
              Smart tax tools for Chartered Accountants
            </p>
          </div>

          {/* Tools */}
          <div>
            <div style={{ fontSize: "11px", fontWeight: 700, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "16px" }}>Tools</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {TOOL_LINKS.map(l => (
                <Link key={l.path} to={l.path} className="footer-link" style={{ fontSize: "13px" }}>{l.label}</Link>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <div style={{ fontSize: "11px", fontWeight: 700, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "16px" }}>Company</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {COMPANY_LINKS.map(l => (
                <Link key={l.path} to={l.path} className="footer-link" style={{ fontSize: "13px" }}>
                  {"labelKey" in l ? t(l.labelKey as string) : l.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <div style={{ fontSize: "11px", fontWeight: 700, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "16px" }}>Legal</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {LEGAL_LINKS.map(l => (
                <Link key={l.path} to={l.path} className="footer-link" style={{ fontSize: "13px" }}>{t(l.labelKey)}</Link>
              ))}
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <div style={{ fontSize: "11px", fontWeight: 700, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "14px" }}>Tax Updates</div>
            <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.4)", marginBottom: "14px", lineHeight: 1.6 }}>Get important tax updates for CAs</p>
            {subscribed ? (
              <div style={{ fontSize: "13px", color: "#C9A84C", fontWeight: 600 }}>✓ Subscribed!</div>
            ) : (
              <form onSubmit={handleSubscribe} style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", padding: "9px 12px", fontSize: "13px", color: "white", outline: "none", width: "100%" }}
                />
                <button type="submit" style={{ background: "#C9A84C", color: "#0A0A0A", border: "none", borderRadius: "8px", padding: "9px 16px", fontWeight: 700, fontSize: "13px", cursor: "pointer" }}>
                  Subscribe
                </button>
              </form>
            )}
            <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.2)", marginTop: "8px" }}>No spam. Only important tax updates.</p>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: "1px", background: "rgba(255,255,255,0.06)", marginBottom: "24px" }} />

        {/* Bottom row */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
          <div style={{ color: "rgba(255,255,255,0.2)", fontSize: "12px" }}>
            © 2026 TaxThinker. {t("footer.tagline")}
          </div>
          <div style={{ color: "rgba(255,255,255,0.2)", fontSize: "12px" }}>
            Made with ❤️ for CAs in India
          </div>
        </div>
      </div>
    </footer>
  );
}
